export class SaslSecretProbe {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasRequiredKeys",
            "baseName": "hasRequiredKeys",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "kmsKeyArn",
            "baseName": "kmsKeyArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "ProbeError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaslSecretProbe.attributeTypeMap;
    }
    constructor() {
    }
}
